import React from 'react'
import { LuClock } from 'react-icons/lu'

import { Alert, AlertDescription } from '@/components/ui/alert'
import {
  COMMERCIAL_AGREEMENT_TYPE,
  REFERRAL_DIRECTION_COMMERCIAL_AGREEMENT_STATUS,
} from '@/lib/constants'
import commercialAgreementService from '@/lib/services/commercialAgreementService'
import { CommercialAgreementReferralDirection } from '@/types/misc'
import {
  PanelItem,
  PanelItemCommercialAgreement,
} from '@/types/responses/panels'

interface Props {
  panel: PanelItem
  referralDirection: CommercialAgreementReferralDirection
  agreement: PanelItemCommercialAgreement
}

const AgreementStatusMessage: React.FC<Props> = ({
  panel,
  referralDirection,
  agreement,
}) => {
  const agreementStatus =
    commercialAgreementService.isOutgoingAgreementDirection(referralDirection)
      ? panel.outgoingAgreementStatus
      : panel.incomingAgreementStatus

  const isPendingReviewByUs = agreement?.isCurrentAgreement
    ? agreementStatus ===
      REFERRAL_DIRECTION_COMMERCIAL_AGREEMENT_STATUS.CURRENT_AGREEMENT_AWAITING_REVIEW_BY_US
    : agreementStatus ===
      REFERRAL_DIRECTION_COMMERCIAL_AGREEMENT_STATUS.PENDING_AGREEMENT_AWAITING_REVIEW_BY_US

  const isPendingReviewByThem = agreement?.isCurrentAgreement
    ? agreementStatus ===
      REFERRAL_DIRECTION_COMMERCIAL_AGREEMENT_STATUS.CURRENT_AGREEMENT_AWAITING_REVIEW_BY_THEM
    : agreementStatus ===
      REFERRAL_DIRECTION_COMMERCIAL_AGREEMENT_STATUS.PENDING_AGREEMENT_AWAITING_REVIEW_BY_THEM

  return (
    <>
      {isPendingReviewByUs && (
        <Alert variant="warning" className="my-4">
          <LuClock className="text-lg" />

          <AlertDescription>
            {agreement.isCurrentAgreement ? (
              <p>
                Your referral partner added the details of your commercial
                agreement. If you agree with this, please press 'Confirm' below
                or press 'Amend agreement' to request changes.
              </p>
            ) : (
              <p>
                Your referral partner added the details of your commercial
                agreement. If you agree with this, please press 'Approve
                changes' below or 'Reject changes' if you don't. Alternatively,
                press 'Amend agreement' to request changes.
              </p>
            )}
          </AlertDescription>
        </Alert>
      )}

      {isPendingReviewByThem && (
        <Alert variant="warning" className="my-4">
          <LuClock className="mt-0.5 text-lg" />
          <AlertDescription>
            <p>
              {agreement.commercialAgreementType ===
              COMMERCIAL_AGREEMENT_TYPE.NO
                ? 'You have advised that there is no commercial agreement in place.'
                : 'You have added the details of your commercial agreement with this firm.'}{' '}
              We are waiting for confirmation from your referral partner.
            </p>
          </AlertDescription>
        </Alert>
      )}
    </>
  )
}

export default AgreementStatusMessage
